import React from "react";
import { NavLink, useMatch, useResolvedPath } from "react-router-dom";
import generateAttributes from "../../../functions/generateAttributes";
import "../../../styles/components/Menu/MenuItem.scss";

function MenuItem(props) {
    const resolved = useResolvedPath(props.to);
    const match = useMatch({ path: resolved.pathname, end: true });
    const attr = generateAttributes("MenuItem", props, {
        active: !!match,
        menuOpen: props.menuOpen,
        menuTopOfPage: props.menuTopOfPage,
    });

    return (
        <NavLink
            {...attr()}
            to={props.to}
            end
            tabIndex={props.focusable === false ? "-1" : ""}
            onMouseDown={(e) => e.preventDefault()} // Prevents focus styles on click
        >
            {props.text}
        </NavLink>
    );
}

export default MenuItem;
